import cn from './SummaryPanel.module.scss'

interface SummaryItem {
  label: string
  value: string | number
  hint?: string
}

interface SummaryPanelProps {
  totalItems: number
  totals: SummaryItem[]
  className?: string
  blueTheme?: boolean
}

const SummaryPanel = ({
  totalItems,
  totals,
  className,
  blueTheme = false,
}: SummaryPanelProps) => {
  return (
    <div
      className={[
        cn.summarySticky,
        blueTheme ? cn.summaryStickyBlue : cn.summaryStickyOrange,
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={cn.selectedCountBlock}>
        <p>
          Всего товаров: <b>{totalItems}</b>
        </p>
      </div>

      <div className={cn.summaryTotals}>
        {totals.map((item) => (
          <p key={item.label}>
            {item.label}: <b>{item.value}</b>
            {item.hint && <span className={cn.summaryHint}>{item.hint}</span>}
          </p>
        ))}
      </div>
    </div>
  )
}

export default SummaryPanel
